/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { BsPrinter } from "react-icons/bs";
import { FiFilePlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { bindActionCreators } from "redux";
import { userDataActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import Loader from "../../Loader";
import RenderHome from "../home/RenderHome";
import DeductionsView, { ToolbarButton } from "./DeductionsView";
import "./Loans.css";

function Loans() {
  const dispatch = useDispatch();
  const { GetLoans, GetAppliedLoans } = bindActionCreators(userDataActionCreators, dispatch);

  const loans = useSelector((state) => state.user.loans);
  const paginate = useSelector((state) => state.user.paginate);
  const isLoading = useSelector((state) => state.user.isLoading);

  const [pageCount, setPageCount] = useState(0);
  const componentRef = useRef();

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [loans, paginate]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    GetLoans(true, event.selected + 1, 15);
  };

  useEffect(() => {
    GetLoans(true, 1, 15);
    GetAppliedLoans();

    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "My Loan Deductions",
  });

  const handleSearch = debounce((e) => {
    if (e.target.value) {
      GetLoans(true, 1, 10, `${e.target.value}`);
    } else {
      GetLoans(true, 1, 10);
    }
  }, 800);

  return (
    <div className="LoansPage">
      <RenderHome title={"Loans"}>
        {isLoading ? <Loader /> : ""}

        <DeductionsView
          ref={componentRef}
          title="Loan Deductions"
          subtitle="Every loan repayment deducted from your salary, newest month first."
          tableTitle="Loan Deductions"
          rows={loans}
          totalRecords={paginate?.totalItems}
          onSearch={handleSearch}
          pageCount={pageCount}
          onPageChange={handlePageClick}
          emptyText="No loan deductions recorded yet."
          actions={
            <>
              <ToolbarButton icon={BsPrinter} label="Print" onClick={handlePrint} />
              <ToolbarButton
                icon={FiFilePlus}
                tone="solid"
                label="Apply for a Loan"
                to={<Link to="/apply-loan-personal_info" />}
              />
            </>
          }
        />
      </RenderHome>
    </div>
  );
}

export default Loans;
